// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { deleteCollectiveOffersByOfferIdImageData, deleteCollectiveOffersByOfferIdImageErrors, deleteCollectiveOffersByOfferIdImageResponses, deleteCollectiveOffersTemplateByOfferIdImageData, deleteCollectiveOffersTemplateByOfferIdImageErrors, deleteCollectiveOffersTemplateByOfferIdImageResponses, deleteOffersThumbnailsByOfferIdData, deleteOffersThumbnailsByOfferIdErrors, deleteOffersThumbnailsByOfferIdResponses, deleteVenueProvidersByVenueProviderIdData, deleteVenueProvidersByVenueProviderIdErrors, deleteVenueProvidersByVenueProviderIdResponses, deleteVenuesByVenueIdBannerData, deleteVenuesByVenueIdBannerErrors, deleteVenuesByVenueIdBannerResponses, getArtistsData, getArtistsErrors, getArtistsResponses, getBookingsCsvData, getBookingsCsvErrors, getBookingsCsvResponses, getBookingsDatesByOfferIdData, getBookingsDatesByOfferIdErrors, getBookingsDatesByOfferIdResponses, getBookingsExcelData, getBookingsExcelErrors, getBookingsExcelResponses, getBookingsOfferByOfferIdCsvData, getBookingsOfferByOfferIdCsvErrors, getBookingsOfferByOfferIdCsvResponses, getBookingsOfferByOfferIdExcelData, getBookingsOfferByOfferIdExcelErrors, getBookingsOfferByOfferIdExcelResponses, getBookingsProData, getBookingsProErrors, getBookingsProResponses, getBookingsProUserHasBookingsData, getBookingsProUserHasBookingsErrors, getBookingsProUserHasBookingsResponses, getBookingsTokenByTokenData, getBookingsTokenByTokenErrors, getBookingsTokenByTokenResponses, getCapabilitiesData, getCapabilitiesErrors, getCapabilitiesResponses, getCollectiveBookableOffersData, getCollectiveBookableOffersErrors, getCollectiveBookableOffersResponses, getCollectiveEducationalDomainsData, getCollectiveEducationalDomainsErrors, getCollectiveEducationalDomainsResponses, getCollectiveHomeBookableOffersData, getCollectiveHomeBookableOffersErrors, getCollectiveHomeBookableOffersResponses, getCollectiveHomeOffersTemplateData, getCollectiveHomeOffersTemplateErrors, getCollectiveHomeOffersTemplateResponses, getCollectiveOffersByOfferIdData, getCollectiveOffersByOfferIdErrors, getCollectiveOffersByOfferIdResponses, getCollectiveOffersCsvData, getCollectiveOffersCsvErrors, getCollectiveOffersCsvResponses, getCollectiveOffersExcelData, getCollectiveOffersExcelErrors, getCollectiveOffersExcelResponses, getCollectiveOffersRedactorsData, getCollectiveOffersRedactorsErrors, getCollectiveOffersRedactorsResponses, getCollectiveOffersTemplateByOfferIdData, getCollectiveOffersTemplateByOfferIdErrors, getCollectiveOffersTemplateByOfferIdResponses, getCollectiveOffersTemplateData, getCollectiveOffersTemplateErrors, getCollectiveOffersTemplateRequestByRequestIdData, getCollectiveOffersTemplateRequestByRequestIdErrors, getCollectiveOffersTemplateRequestByRequestIdResponses, getCollectiveOffersTemplateResponses, getEducationalInstitutionsData, getEducationalInstitutionsErrors, getEducationalInstitutionsResponses, getFeaturesData, getFeaturesErrors, getFeaturesResponses, getFinanceCombinedInvoicesData, getFinanceCombinedInvoicesErrors, getFinanceCombinedInvoicesResponses, getFinanceHasInvoiceData, getFinanceHasInvoiceErrors, getFinanceHasInvoiceResponses, getFinanceHasSettlementData, getFinanceHasSettlementErrors, getFinanceHasSettlementResponses, getFinanceInvoicesData, getFinanceInvoicesErrors, getFinanceInvoicesResponses, getFinanceReimbursementsCsvData, getFinanceReimbursementsCsvErrors, getFinanceReimbursementsCsvResponses, getFinanceRejectedBankAccountsData, getFinanceRejectedBankAccountsErrors, getFinanceRejectedBankAccountsResponses, getFinanceSettlementsData, getFinanceSettlementsErrors, getFinanceSettlementsResponses, getGetOfferVideoDataData, getGetOfferVideoDataErrors, getGetOfferVideoDataResponses, getGetProductByEanByEanByOffererIdData, getGetProductByEanByEanByOffererIdErrors, getGetProductByEanByEanByOffererIdResponses, getGetStatisticsData, getGetStatisticsErrors, getGetStatisticsResponses, getHighlightsData, getHighlightsErrors, getHighlightsResponses, getNatureFormatDomainData, getNatureFormatDomainErrors, getNatureFormatDomainResponses, getOfferersByOffererIdBankAccountsData, getOfferersByOffererIdBankAccountsErrors, getOfferersByOffererIdBankAccountsResponses, getOfferersByOffererIdData, getOfferersByOffererIdErrors, getOfferersByOffererIdMembersData, getOfferersByOffererIdMembersErrors, getOfferersByOffererIdMembersResponses, getOfferersByOffererIdOffererAddressesData, getOfferersByOffererIdOffererAddressesErrors, getOfferersByOffererIdOffererAddressesResponses, getOfferersByOffererIdResponses, getOfferersEducationalData, getOfferersEducationalErrors, getOfferersEducationalResponses, getOfferersNamesData, getOfferersNamesErrors, getOfferersNamesResponses, getOffersByOfferIdData, getOffersByOfferIdErrors, getOffersByOfferIdExposureData, getOffersByOfferIdExposureErrors, getOffersByOfferIdExposureResponses, getOffersByOfferIdResponses, getOffersByOfferIdStocksData, getOffersByOfferIdStocksErrors, getOffersByOfferIdStocksResponses, getOffersByOfferIdStocksStatsData, getOffersByOfferIdStocksStatsErrors, getOffersByOfferIdStocksStatsResponses, getOffersByVenueIdEanByEanData, getOffersByVenueIdEanByEanErrors, getOffersByVenueIdEanByEanResponses, getOffersCategoriesData, getOffersCategoriesErrors, getOffersCategoriesResponses, getOffersData, getOffersErrors, getOffersHomeData, getOffersHomeErrors, getOffersHomeResponses, getOffersMusicTypesData, getOffersMusicTypesErrors, getOffersMusicTypesResponses, getOffersResponses, getStructureCheckBySearchInputData, getStructureCheckBySearchInputErrors, getStructureCheckBySearchInputResponses, getStructureSearchBySearchInputData, getStructureSearchBySearchInputErrors, getStructureSearchBySearchInputResponses, getUsersAnonymizeEligibilityData, getUsersAnonymizeEligibilityErrors, getUsersAnonymizeEligibilityResponses, getUsersConnectAsByTokenData, getUsersConnectAsByTokenErrors, getUsersConnectAsByTokenResponses, getUsersCurrentData, getUsersCurrentErrors, getUsersCurrentResponses, getUsersEmailPendingValidationData, getUsersEmailPendingValidationErrors, getUsersEmailPendingValidationResponses, getUsersSignoutData, getUsersSignoutErrors, getUsersSignoutResponses, getVenuesByVenueIdData, getVenuesByVenueIdErrors, getVenuesByVenueIdHeadlineOfferData, getVenuesByVenueIdHeadlineOfferErrors, getVenuesByVenueIdHeadlineOfferResponses, getVenuesByVenueIdLocationsData, getVenuesByVenueIdLocationsErrors, getVenuesByVenueIdLocationsResponses, getVenuesByVenueIdOffersStatisticsData, getVenuesByVenueIdOffersStatisticsErrors, getVenuesByVenueIdOffersStatisticsResponses, getVenuesByVenueIdOffersStatisticsV2Data, getVenuesByVenueIdOffersStatisticsV2Errors, getVenuesByVenueIdOffersStatisticsV2Responses, getVenuesByVenueIdProvidersData, getVenuesByVenueIdProvidersErrors, getVenuesByVenueIdProvidersResponses, getVenuesByVenueIdResponses, getVenuesByVenueIdVenueProvidersData, getVenuesByVenueIdVenueProvidersErrors, getVenuesByVenueIdVenueProvidersResponses, getVenuesData, getVenuesEducationalStatusesData, getVenuesEducationalStatusesErrors, getVenuesEducationalStatusesResponses, getVenuesErrors, getVenuesResponses, getVenuesSiretBySiretData, getVenuesSiretBySiretErrors, getVenuesSiretBySiretResponses, patchBookingsKeepTokenByTokenData, patchBookingsKeepTokenByTokenErrors, patchBookingsKeepTokenByTokenResponses, patchBookingsUseTokenByTokenData, patchBookingsUseTokenByTokenErrors, patchBookingsUseTokenByTokenResponses, patchCollectiveOffersArchiveData, patchCollectiveOffersArchiveErrors, patchCollectiveOffersArchiveResponses, patchCollectiveOffersByOfferIdCancelBookingData, patchCollectiveOffersByOfferIdCancelBookingErrors, patchCollectiveOffersByOfferIdCancelBookingResponses, patchCollectiveOffersByOfferIdData, patchCollectiveOffersByOfferIdEducationalInstitutionData, patchCollectiveOffersByOfferIdEducationalInstitutionErrors, patchCollectiveOffersByOfferIdEducationalInstitutionResponses, patchCollectiveOffersByOfferIdErrors, patchCollectiveOffersByOfferIdPublishData, patchCollectiveOffersByOfferIdPublishErrors, patchCollectiveOffersByOfferIdPublishResponses, patchCollectiveOffersByOfferIdResponses, patchCollectiveOffersTemplateActiveStatusData, patchCollectiveOffersTemplateActiveStatusErrors, patchCollectiveOffersTemplateActiveStatusResponses, patchCollectiveOffersTemplateArchiveData, patchCollectiveOffersTemplateArchiveErrors, patchCollectiveOffersTemplateArchiveResponses, patchCollectiveOffersTemplateByOfferIdData, patchCollectiveOffersTemplateByOfferIdErrors, patchCollectiveOffersTemplateByOfferIdPublishData, patchCollectiveOffersTemplateByOfferIdPublishErrors, patchCollectiveOffersTemplateByOfferIdPublishResponses, patchCollectiveOffersTemplateByOfferIdResponses, patchCollectiveStocksByCollectiveStockIdData, patchCollectiveStocksByCollectiveStockIdErrors, patchCollectiveStocksByCollectiveStockIdResponses, patchOfferersByOffererIdBankAccountsByBankAccountIdData, patchOfferersByOffererIdBankAccountsByBankAccountIdErrors, patchOfferersByOffererIdBankAccountsByBankAccountIdResponses, patchOffersActiveStatusData, patchOffersActiveStatusErrors, patchOffersActiveStatusResponses, patchOffersAllActiveStatusData, patchOffersAllActiveStatusErrors, patchOffersAllActiveStatusResponses, patchOffersByOfferIdData, patchOffersByOfferIdErrors, patchOffersByOfferIdResponses, patchOffersByOfferIdStocksData, patchOffersByOfferIdStocksErrors, patchOffersByOfferIdStocksResponses, patchOffersPublishData, patchOffersPublishErrors, patchOffersPublishResponses, patchStocksBulkData, patchStocksBulkErrors, patchStocksBulkResponses, patchUsersIdentityData, patchUsersIdentityErrors, patchUsersIdentityResponses, patchUsersPhoneData, patchUsersPhoneErrors, patchUsersPhoneResponses, patchUsersValidateEmailData, patchUsersValidateEmailErrors, patchUsersValidateEmailResponses, patchUsersValidateSignupByTokenData, patchUsersValidateSignupByTokenErrors, patchUsersValidateSignupByTokenResponses, patchVenuesByVenueIdCollectiveDataData, patchVenuesByVenueIdCollectiveDataErrors, patchVenuesByVenueIdCollectiveDataResponses, patchVenuesByVenueIdData, patchVenuesByVenueIdErrors, patchVenuesByVenueIdResponses, postCollectiveOffersByOfferIdDuplicateData, postCollectiveOffersByOfferIdDuplicateErrors, postCollectiveOffersByOfferIdDuplicateResponses, postCollectiveOffersByOfferIdImageData, postCollectiveOffersByOfferIdImageErrors, postCollectiveOffersByOfferIdImageResponses, postCollectiveOffersData, postCollectiveOffersErrors, postCollectiveOffersResponses, postCollectiveOffersTemplateByOfferIdImageData, postCollectiveOffersTemplateByOfferIdImageErrors, postCollectiveOffersTemplateByOfferIdImageResponses, postCollectiveOffersTemplateData, postCollectiveOffersTemplateErrors, postCollectiveOffersTemplateResponses, postCollectiveStocksData, postCollectiveStocksErrors, postCollectiveStocksResponses, postOfferersByOffererIdInviteAgainData, postOfferersByOffererIdInviteAgainErrors, postOfferersByOffererIdInviteAgainResponses, postOfferersByOffererIdInviteData, postOfferersByOffererIdInviteErrors, postOfferersByOffererIdInviteResponses, postOfferersByOffererIdSynchronizeOnboardingData, postOfferersByOffererIdSynchronizeOnboardingErrors, postOfferersByOffererIdSynchronizeOnboardingResponses, postOfferersData, postOfferersErrors, postOfferersNewData, postOfferersNewErrors, postOfferersNewResponses, postOfferersResponses, postOffersByOfferIdHighlightRequestsData, postOffersByOfferIdHighlightRequestsErrors, postOffersByOfferIdHighlightRequestsResponses, postOffersByOfferIdStocksDeleteData, postOffersByOfferIdStocksDeleteErrors, postOffersByOfferIdStocksDeleteResponses, postOffersDeleteDraftData, postOffersDeleteDraftErrors, postOffersDeleteDraftResponses, postOffersDeleteHeadlineData, postOffersDeleteHeadlineErrors, postOffersDeleteHeadlineResponses, postOffersThumbnailsData, postOffersThumbnailsErrors, postOffersThumbnailsResponses, postOffersUpsertHeadlineData, postOffersUpsertHeadlineErrors, postOffersUpsertHeadlineResponses, postStocksBulkData, postStocksBulkErrors, postStocksBulkResponses, postStructureSimulateSignupData, postStructureSimulateSignupErrors, postStructureSimulateSignupResponses, postStructureSummariseSignupData, postStructureSummariseSignupErrors, postStructureSummariseSignupResponses, postUsersAnonymizeData, postUsersAnonymizeErrors, postUsersAnonymizeResponses, postUsersCheckTokenData, postUsersCheckTokenErrors, postUsersCheckTokenResponses, postUsersCookiesData, postUsersCookiesErrors, postUsersCookiesResponses, postUsersEmailData, postUsersEmailErrors, postUsersEmailResponses, postUsersLogUserReviewData, postUsersLogUserReviewErrors, postUsersLogUserReviewResponses, postUsersNewPasswordData, postUsersNewPasswordErrors, postUsersNewPasswordResponses, postUsersPasswordData, postUsersPasswordErrors, postUsersPasswordResponses, postUsersResetPasswordData, postUsersResetPasswordErrors, postUsersResetPasswordResponses, postUsersSigninData, postUsersSigninErrors, postUsersSigninResponses, postUsersSignupData, postUsersSignupErrors, postUsersSignupResponses, postV2OffersData, postV2OffersErrors, postV2OffersResponses, postVenuesByVenueIdCloseData, postVenuesByVenueIdCloseErrors, postVenuesByVenueIdCloseResponses, postVenuesByVenueIdPricingPointData, postVenuesByVenueIdPricingPointErrors, postVenuesByVenueIdPricingPointResponses, postVenuesByVenueIdVenueProvidersData, postVenuesByVenueIdVenueProvidersErrors, postVenuesByVenueIdVenueProvidersResponses, putOffersByOfferIdPriceCategoriesData, putOffersByOfferIdPriceCategoriesErrors, putOffersByOfferIdPriceCategoriesResponses, putOffersByOfferIdVideoData, putOffersByOfferIdVideoErrors, putOffersByOfferIdVideoResponses, putVenueProvidersByVenueProviderIdData, putVenueProvidersByVenueProviderIdErrors, putVenueProvidersByVenueProviderIdResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * get_artists <GET>
 */
export const getArtists = <ThrowOnError extends boolean = true>(options: Options<getArtistsData, ThrowOnError>): RequestResult<getArtistsResponses, getArtistsErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getArtistsResponses, getArtistsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/artists',
    ...options
});

/**
 * get_bookings_csv <GET>
 */
export const getBookingsCsv = <ThrowOnError extends boolean = true>(options: Options<getBookingsCsvData, ThrowOnError>): RequestResult<getBookingsCsvResponses, getBookingsCsvErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getBookingsCsvResponses, getBookingsCsvErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/bookings/csv',
    ...options
});

/**
 * get_offer_price_categories_and_schedules_by_dates <GET>
 */
export const getOfferPriceCategoriesAndSchedulesByDates = <ThrowOnError extends boolean = true>(options: Options<getBookingsDatesByOfferIdData, ThrowOnError>): RequestResult<getBookingsDatesByOfferIdResponses, getBookingsDatesByOfferIdErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getBookingsDatesByOfferIdResponses, getBookingsDatesByOfferIdErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/bookings/dates/{offer_id}',
    ...options
});

/**
 * get_bookings_excel <GET>
 */
export const getBookingsExcel = <ThrowOnError extends boolean = true>(options: Options<getBookingsExcelData, ThrowOnError>): RequestResult<getBookingsExcelResponses, getBookingsExcelErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getBookingsExcelResponses, getBookingsExcelErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/bookings/excel',
    ...options
});

/**
 * patch_booking_keep_by_token <PATCH>
 */
export const patchBookingKeepByToken = <ThrowOnError extends boolean = true>(options: Options<patchBookingsKeepTokenByTokenData, ThrowOnError>): RequestResult<patchBookingsKeepTokenByTokenResponses, patchBookingsKeepTokenByTokenErrors, ThrowOnError, 'data'> => (options.client ?? client).patch<patchBookingsKeepTokenByTokenResponses, patchBookingsKeepTokenByTokenErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/bookings/keep/token/{token}',
    ...options
});

/**
 * export_bookings_for_offer_as_csv <GET>
 */
export const exportBookingsForOfferAsCsv = <ThrowOnError extends boolean = true>(options: Options<getBookingsOfferByOfferIdCsvData, ThrowOnError>): RequestResult<getBookingsOfferByOfferIdCsvResponses, getBookingsOfferByOfferIdCsvErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getBookingsOfferByOfferIdCsvResponses, getBookingsOfferByOfferIdCsvErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/bookings/offer/{offer_id}/csv',
    ...options
});

/**
 * export_bookings_for_offer_as_excel <GET>
 */
export const exportBookingsForOfferAsExcel = <ThrowOnError extends boolean = true>(options: Options<getBookingsOfferByOfferIdExcelData, ThrowOnError>): RequestResult<getBookingsOfferByOfferIdExcelResponses, getBookingsOfferByOfferIdExcelErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getBookingsOfferByOfferIdExcelResponses, getBookingsOfferByOfferIdExcelErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/bookings/offer/{offer_id}/excel',
    ...options
});

/**
 * get_bookings_pro <GET>
 */
export const getBookingsPro = <ThrowOnError extends boolean = true>(options: Options<getBookingsProData, ThrowOnError>): RequestResult<getBookingsProResponses, getBookingsProErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getBookingsProResponses, getBookingsProErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/bookings/pro',
    ...options
});

/**
 * get_user_has_bookings <GET>
 */
export const getUserHasBookings = <ThrowOnError extends boolean = true>(options?: Options<getBookingsProUserHasBookingsData, ThrowOnError>): RequestResult<getBookingsProUserHasBookingsResponses, getBookingsProUserHasBookingsErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<getBookingsProUserHasBookingsResponses, getBookingsProUserHasBookingsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/bookings/pro/userHasBookings',
    ...options
});

/**
 * get_booking_by_token <GET>
 */
export const getBookingByToken = <ThrowOnError extends boolean = true>(options: Options<getBookingsTokenByTokenData, ThrowOnError>): RequestResult<getBookingsTokenByTokenResponses, getBookingsTokenByTokenErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getBookingsTokenByTokenResponses, getBookingsTokenByTokenErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/bookings/token/{token}',
    ...options
});

/**
 * patch_booking_use_by_token <PATCH>
 */
export const patchBookingUseByToken = <ThrowOnError extends boolean = true>(options: Options<patchBookingsUseTokenByTokenData, ThrowOnError>): RequestResult<patchBookingsUseTokenByTokenResponses, patchBookingsUseTokenByTokenErrors, ThrowOnError, 'data'> => (options.client ?? client).patch<patchBookingsUseTokenByTokenResponses, patchBookingsUseTokenByTokenErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/bookings/use/token/{token}',
    ...options
});

/**
 * get_capabilities <GET>
 */
export const getCapabilities = <ThrowOnError extends boolean = true>(options: Options<getCapabilitiesData, ThrowOnError>): RequestResult<getCapabilitiesResponses, getCapabilitiesErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getCapabilitiesResponses, getCapabilitiesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/capabilities',
    ...options
});

/**
 * get_collective_offers <GET>
 */
export const getCollectiveOffers = <ThrowOnError extends boolean = true>(options?: Options<getCollectiveBookableOffersData, ThrowOnError>): RequestResult<getCollectiveBookableOffersResponses, getCollectiveBookableOffersErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<getCollectiveBookableOffersResponses, getCollectiveBookableOffersErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/collective/bookable-offers',
    ...options
});

/**
 * list_educational_domains <GET>
 */
export const listEducationalDomains = <ThrowOnError extends boolean = true>(options?: Options<getCollectiveEducationalDomainsData, ThrowOnError>): RequestResult<getCollectiveEducationalDomainsResponses, getCollectiveEducationalDomainsErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<getCollectiveEducationalDomainsResponses, getCollectiveEducationalDomainsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/collective/educational-domains',
    ...options
});

/**
 * get_collective_offers_home <GET>
 */
export const getCollectiveOffersHome = <ThrowOnError extends boolean = true>(options: Options<getCollectiveHomeBookableOffersData, ThrowOnError>): RequestResult<getCollectiveHomeBookableOffersResponses, getCollectiveHomeBookableOffersErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getCollectiveHomeBookableOffersResponses, getCollectiveHomeBookableOffersErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/collective/home/bookable-offers',
    ...options
});

/**
 * get_collective_offer_templates_home <GET>
 */
export const getCollectiveOfferTemplatesHome = <ThrowOnError extends boolean = true>(options: Options<getCollectiveHomeOffersTemplateData, ThrowOnError>): RequestResult<getCollectiveHomeOffersTemplateResponses, getCollectiveHomeOffersTemplateErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getCollectiveHomeOffersTemplateResponses, getCollectiveHomeOffersTemplateErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/collective/home/offers-template',
    ...options
});

/**
 * create_collective_offer <POST>
 */
export const createCollectiveOffer = <ThrowOnError extends boolean = true>(options: Options<postCollectiveOffersData, ThrowOnError>): RequestResult<postCollectiveOffersResponses, postCollectiveOffersErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postCollectiveOffersResponses, postCollectiveOffersErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/collective/offers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * get_collective_offer_templates <GET>
 */
export const getCollectiveOfferTemplates = <ThrowOnError extends boolean = true>(options?: Options<getCollectiveOffersTemplateData, ThrowOnError>): RequestResult<getCollectiveOffersTemplateResponses, getCollectiveOffersTemplateErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<getCollectiveOffersTemplateResponses, getCollectiveOffersTemplateErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/collective/offers-template',
    ...options
});

/**
 * create_collective_offer_template <POST>
 */
export const createCollectiveOfferTemplate = <ThrowOnError extends boolean = true>(options: Options<postCollectiveOffersTemplateData, ThrowOnError>): RequestResult<postCollectiveOffersTemplateResponses, postCollectiveOffersTemplateErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postCollectiveOffersTemplateResponses, postCollectiveOffersTemplateErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/collective/offers-template',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * patch_collective_offers_template_active_status <PATCH>
 */
export const patchCollectiveOffersTemplateActiveStatus = <ThrowOnError extends boolean = true>(options: Options<patchCollectiveOffersTemplateActiveStatusData, ThrowOnError>): RequestResult<patchCollectiveOffersTemplateActiveStatusResponses, patchCollectiveOffersTemplateActiveStatusErrors, ThrowOnError, 'data'> => (options.client ?? client).patch<patchCollectiveOffersTemplateActiveStatusResponses, patchCollectiveOffersTemplateActiveStatusErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/collective/offers-template/active-status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * patch_collective_offers_template_archive <PATCH>
 */
export const patchCollectiveOffersTemplateArchive = <ThrowOnError extends boolean = true>(options: Options<patchCollectiveOffersTemplateArchiveData, ThrowOnError>): RequestResult<patchCollectiveOffersTemplateArchiveResponses, patchCollectiveOffersTemplateArchiveErrors, ThrowOnError, 'data'> => (options.client ?? client).patch<patchCollectiveOffersTemplateArchiveResponses, patchCollectiveOffersTemplateArchiveErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/collective/offers-template/archive',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * get_collective_offer_request <GET>
 */
export const getCollectiveOfferRequest = <ThrowOnError extends boolean = true>(options: Options<getCollectiveOffersTemplateRequestByRequestIdData, ThrowOnError>): RequestResult<getCollectiveOffersTemplateRequestByRequestIdResponses, getCollectiveOffersTemplateRequestByRequestIdErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getCollectiveOffersTemplateRequestByRequestIdResponses, getCollectiveOffersTemplateRequestByRequestIdErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/collective/offers-template/request/{request_id}',
    ...options
});

/**
 * get_collective_offer_template <GET>
 */
export const getCollectiveOfferTemplate = <ThrowOnError extends boolean = true>(options: Options<getCollectiveOffersTemplateByOfferIdData, ThrowOnError>): RequestResult<getCollectiveOffersTemplateByOfferIdResponses, getCollectiveOffersTemplateByOfferIdErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getCollectiveOffersTemplateByOfferIdResponses, getCollectiveOffersTemplateByOfferIdErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/collective/offers-template/{offer_id}',
    ...options
});

/**
 * edit_collective_offer_template <PATCH>
 */
export const editCollectiveOfferTemplate = <ThrowOnError extends boolean = true>(options: Options<patchCollectiveOffersTemplateByOfferIdData, ThrowOnError>): RequestResult<patchCollectiveOffersTemplateByOfferIdResponses, patchCollectiveOffersTemplateByOfferIdErrors, ThrowOnError, 'data'> => (options.client ?? client).patch<patchCollectiveOffersTemplateByOfferIdResponses, patchCollectiveOffersTemplateByOfferIdErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/collective/offers-template/{offer_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * delete_offer_template_image <DELETE>
 */
export const deleteOfferTemplateImage = <ThrowOnError extends boolean = true>(options: Options<deleteCollectiveOffersTemplateByOfferIdImageData, ThrowOnError>): RequestResult<deleteCollectiveOffersTemplateByOfferIdImageResponses, deleteCollectiveOffersTemplateByOfferIdImageErrors, ThrowOnError, 'data'> => (options.client ?? client).delete<deleteCollectiveOffersTemplateByOfferIdImageResponses, deleteCollectiveOffersTemplateByOfferIdImageErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/collective/offers-template/{offer_id}/image',
    ...options
});

/**
 * attach_offer_template_image <POST>
 */
export const attachOfferTemplateImage = <ThrowOnError extends boolean = true>(options: Options<postCollectiveOffersTemplateByOfferIdImageData, ThrowOnError>): RequestResult<postCollectiveOffersTemplateByOfferIdImageResponses, postCollectiveOffersTemplateByOfferIdImageErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postCollectiveOffersTemplateByOfferIdImageResponses, postCollectiveOffersTemplateByOfferIdImageErrors, ThrowOnError, 'data'>({
    ...formDataBodySerializer,
    responseStyle: 'data',
    url: '/collective/offers-template/{offer_id}/image',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * patch_collective_offer_template_publication <PATCH>
 */
export const patchCollectiveOfferTemplatePublication = <ThrowOnError extends boolean = true>(options: Options<patchCollectiveOffersTemplateByOfferIdPublishData, ThrowOnError>): RequestResult<patchCollectiveOffersTemplateByOfferIdPublishResponses, patchCollectiveOffersTemplateByOfferIdPublishErrors, ThrowOnError, 'data'> => (options.client ?? client).patch<patchCollectiveOffersTemplateByOfferIdPublishResponses, patchCollectiveOffersTemplateByOfferIdPublishErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/collective/offers-template/{offer_id}/publish',
    ...options
});

/**
 * patch_collective_offers_archive <PATCH>
 */
export const patchCollectiveOffersArchive = <ThrowOnError extends boolean = true>(options: Options<patchCollectiveOffersArchiveData, ThrowOnError>): RequestResult<patchCollectiveOffersArchiveResponses, patchCollectiveOffersArchiveErrors, ThrowOnError, 'data'> => (options.client ?? client).patch<patchCollectiveOffersArchiveResponses, patchCollectiveOffersArchiveErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/collective/offers/archive',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * get_collective_offers_csv <GET>
 */
export const getCollectiveOffersCsv = <ThrowOnError extends boolean = true>(options?: Options<getCollectiveOffersCsvData, ThrowOnError>): RequestResult<getCollectiveOffersCsvResponses, getCollectiveOffersCsvErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<getCollectiveOffersCsvResponses, getCollectiveOffersCsvErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/collective/offers/csv',
    ...options
});

/**
 * get_collective_offers_excel <GET>
 */
export const getCollectiveOffersExcel = <ThrowOnError extends boolean = true>(options?: Options<getCollectiveOffersExcelData, ThrowOnError>): RequestResult<getCollectiveOffersExcelResponses, getCollectiveOffersExcelErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<getCollectiveOffersExcelResponses, getCollectiveOffersExcelErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/collective/offers/excel',
    ...options
});

/**
 * get_autocomplete_educational_redactors_for_uai <GET>
 */
export const getAutocompleteEducationalRedactorsForUai = <ThrowOnError extends boolean = true>(options: Options<getCollectiveOffersRedactorsData, ThrowOnError>): RequestResult<getCollectiveOffersRedactorsResponses, getCollectiveOffersRedactorsErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getCollectiveOffersRedactorsResponses, getCollectiveOffersRedactorsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/collective/offers/redactors',
    ...options
});

/**
 * get_collective_offer <GET>
 */
export const getCollectiveOffer = <ThrowOnError extends boolean = true>(options: Options<getCollectiveOffersByOfferIdData, ThrowOnError>): RequestResult<getCollectiveOffersByOfferIdResponses, getCollectiveOffersByOfferIdErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getCollectiveOffersByOfferIdResponses, getCollectiveOffersByOfferIdErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/collective/offers/{offer_id}',
    ...options
});

/**
 * edit_collective_offer <PATCH>
 */
export const editCollectiveOffer = <ThrowOnError extends boolean = true>(options: Options<patchCollectiveOffersByOfferIdData, ThrowOnError>): RequestResult<patchCollectiveOffersByOfferIdResponses, patchCollectiveOffersByOfferIdErrors, ThrowOnError, 'data'> => (options.client ?? client).patch<patchCollectiveOffersByOfferIdResponses, patchCollectiveOffersByOfferIdErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/collective/offers/{offer_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * cancel_collective_offer_booking <PATCH>
 */
export const cancelCollectiveOfferBooking = <ThrowOnError extends boolean = true>(options: Options<patchCollectiveOffersByOfferIdCancelBookingData, ThrowOnError>): RequestResult<patchCollectiveOffersByOfferIdCancelBookingResponses, patchCollectiveOffersByOfferIdCancelBookingErrors, ThrowOnError, 'data'> => (options.client ?? client).patch<patchCollectiveOffersByOfferIdCancelBookingResponses, patchCollectiveOffersByOfferIdCancelBookingErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/collective/offers/{offer_id}/cancel_booking',
    ...options
});

/**
 * duplicate_collective_offer <POST>
 */
export const duplicateCollectiveOffer = <ThrowOnError extends boolean = true>(options: Options<postCollectiveOffersByOfferIdDuplicateData, ThrowOnError>): RequestResult<postCollectiveOffersByOfferIdDuplicateResponses, postCollectiveOffersByOfferIdDuplicateErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postCollectiveOffersByOfferIdDuplicateResponses, postCollectiveOffersByOfferIdDuplicateErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/collective/offers/{offer_id}/duplicate',
    ...options
});

/**
 * patch_collective_offers_educational_institution <PATCH>
 */
export const patchCollectiveOffersEducationalInstitution = <ThrowOnError extends boolean = true>(options: Options<patchCollectiveOffersByOfferIdEducationalInstitutionData, ThrowOnError>): RequestResult<patchCollectiveOffersByOfferIdEducationalInstitutionResponses, patchCollectiveOffersByOfferIdEducationalInstitutionErrors, ThrowOnError, 'data'> => (options.client ?? client).patch<patchCollectiveOffersByOfferIdEducationalInstitutionResponses, patchCollectiveOffersByOfferIdEducationalInstitutionErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/collective/offers/{offer_id}/educational_institution',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * delete_offer_image <DELETE>
 */
export const deleteOfferImage = <ThrowOnError extends boolean = true>(options: Options<deleteCollectiveOffersByOfferIdImageData, ThrowOnError>): RequestResult<deleteCollectiveOffersByOfferIdImageResponses, deleteCollectiveOffersByOfferIdImageErrors, ThrowOnError, 'data'> => (options.client ?? client).delete<deleteCollectiveOffersByOfferIdImageResponses, deleteCollectiveOffersByOfferIdImageErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/collective/offers/{offer_id}/image',
    ...options
});

/**
 * attach_offer_image <POST>
 */
export const attachOfferImage = <ThrowOnError extends boolean = true>(options: Options<postCollectiveOffersByOfferIdImageData, ThrowOnError>): RequestResult<postCollectiveOffersByOfferIdImageResponses, postCollectiveOffersByOfferIdImageErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postCollectiveOffersByOfferIdImageResponses, postCollectiveOffersByOfferIdImageErrors, ThrowOnError, 'data'>({
    ...formDataBodySerializer,
    responseStyle: 'data',
    url: '/collective/offers/{offer_id}/image',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * patch_collective_offer_publication <PATCH>
 */
export const patchCollectiveOfferPublication = <ThrowOnError extends boolean = true>(options: Options<patchCollectiveOffersByOfferIdPublishData, ThrowOnError>): RequestResult<patchCollectiveOffersByOfferIdPublishResponses, patchCollectiveOffersByOfferIdPublishErrors, ThrowOnError, 'data'> => (options.client ?? client).patch<patchCollectiveOffersByOfferIdPublishResponses, patchCollectiveOffersByOfferIdPublishErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/collective/offers/{offer_id}/publish',
    ...options
});

/**
 * create_collective_stock <POST>
 */
export const createCollectiveStock = <ThrowOnError extends boolean = true>(options: Options<postCollectiveStocksData, ThrowOnError>): RequestResult<postCollectiveStocksResponses, postCollectiveStocksErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postCollectiveStocksResponses, postCollectiveStocksErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/collective/stocks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * edit_collective_stock <PATCH>
 */
export const editCollectiveStock = <ThrowOnError extends boolean = true>(options: Options<patchCollectiveStocksByCollectiveStockIdData, ThrowOnError>): RequestResult<patchCollectiveStocksByCollectiveStockIdResponses, patchCollectiveStocksByCollectiveStockIdErrors, ThrowOnError, 'data'> => (options.client ?? client).patch<patchCollectiveStocksByCollectiveStockIdResponses, patchCollectiveStocksByCollectiveStockIdErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/collective/stocks/{collective_stock_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * get_educational_institutions <GET>
 */
export const getEducationalInstitutions = <ThrowOnError extends boolean = true>(options?: Options<getEducationalInstitutionsData, ThrowOnError>): RequestResult<getEducationalInstitutionsResponses, getEducationalInstitutionsErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<getEducationalInstitutionsResponses, getEducationalInstitutionsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/educational_institutions',
    ...options
});

/**
 * list_features <GET>
 */
export const listFeatures = <ThrowOnError extends boolean = true>(options?: Options<getFeaturesData, ThrowOnError>): RequestResult<getFeaturesResponses, getFeaturesErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<getFeaturesResponses, getFeaturesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/features',
    ...options
});

/**
 * get_combined_invoices <GET>
 */
export const getCombinedInvoices = <ThrowOnError extends boolean = true>(options: Options<getFinanceCombinedInvoicesData, ThrowOnError>): RequestResult<getFinanceCombinedInvoicesResponses, getFinanceCombinedInvoicesErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getFinanceCombinedInvoicesResponses, getFinanceCombinedInvoicesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/finance/combined-invoices',
    ...options
});

/**
 * has_invoice <GET>
 */
export const hasInvoice = <ThrowOnError extends boolean = true>(options: Options<getFinanceHasInvoiceData, ThrowOnError>): RequestResult<getFinanceHasInvoiceResponses, getFinanceHasInvoiceErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getFinanceHasInvoiceResponses, getFinanceHasInvoiceErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/finance/has-invoice',
    ...options
});

/**
 * has_settlement <GET>
 */
export const hasSettlement = <ThrowOnError extends boolean = true>(options: Options<getFinanceHasSettlementData, ThrowOnError>): RequestResult<getFinanceHasSettlementResponses, getFinanceHasSettlementErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getFinanceHasSettlementResponses, getFinanceHasSettlementErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/finance/has-settlement',
    ...options
});

/**
 * get_invoices <GET>
 */
export const getInvoices = <ThrowOnError extends boolean = true>(options?: Options<getFinanceInvoicesData, ThrowOnError>): RequestResult<getFinanceInvoicesResponses, getFinanceInvoicesErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<getFinanceInvoicesResponses, getFinanceInvoicesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/finance/invoices',
    ...options
});

/**
 * get_reimbursements_csv <GET>
 */
export const getReimbursementsCsv = <ThrowOnError extends boolean = true>(options: Options<getFinanceReimbursementsCsvData, ThrowOnError>): RequestResult<getFinanceReimbursementsCsvResponses, getFinanceReimbursementsCsvErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getFinanceReimbursementsCsvResponses, getFinanceReimbursementsCsvErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/finance/reimbursements/csv',
    ...options
});

/**
 * get_rejected_bank_accounts <GET>
 */
export const getRejectedBankAccounts = <ThrowOnError extends boolean = true>(options: Options<getFinanceRejectedBankAccountsData, ThrowOnError>): RequestResult<getFinanceRejectedBankAccountsResponses, getFinanceRejectedBankAccountsErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getFinanceRejectedBankAccountsResponses, getFinanceRejectedBankAccountsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/finance/rejected-bank-accounts',
    ...options
});

/**
 * get_settlements <GET>
 */
export const getSettlements = <ThrowOnError extends boolean = true>(options: Options<getFinanceSettlementsData, ThrowOnError>): RequestResult<getFinanceSettlementsResponses, getFinanceSettlementsErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getFinanceSettlementsResponses, getFinanceSettlementsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/finance/settlements',
    ...options
});

/**
 * get_offer_video_metadata <GET>
 */
export const getOfferVideoMetadata = <ThrowOnError extends boolean = true>(options: Options<getGetOfferVideoDataData, ThrowOnError>): RequestResult<getGetOfferVideoDataResponses, getGetOfferVideoDataErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getGetOfferVideoDataResponses, getGetOfferVideoDataErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/get-offer-video-data',
    ...options
});

/**
 * get_statistics <GET>
 */
export const getStatistics = <ThrowOnError extends boolean = true>(options?: Options<getGetStatisticsData, ThrowOnError>): RequestResult<getGetStatisticsResponses, getGetStatisticsErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<getGetStatisticsResponses, getGetStatisticsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/get-statistics',
    ...options
});

/**
 * get_product_by_ean <GET>
 */
export const getProductByEan = <ThrowOnError extends boolean = true>(options: Options<getGetProductByEanByEanByOffererIdData, ThrowOnError>): RequestResult<getGetProductByEanByEanByOffererIdResponses, getGetProductByEanByEanByOffererIdErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getGetProductByEanByEanByOffererIdResponses, getGetProductByEanByEanByOffererIdErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/get_product_by_ean/{ean}/{offerer_id}',
    ...options
});

/**
 * get_highlights <GET>
 */
export const getHighlights = <ThrowOnError extends boolean = true>(options?: Options<getHighlightsData, ThrowOnError>): RequestResult<getHighlightsResponses, getHighlightsErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<getHighlightsResponses, getHighlightsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/highlights',
    ...options
});

/**
 * get_nature_format_domain <GET>
 */
export const getNatureFormatDomain = <ThrowOnError extends boolean = true>(options?: Options<getNatureFormatDomainData, ThrowOnError>): RequestResult<getNatureFormatDomainResponses, getNatureFormatDomainErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<getNatureFormatDomainResponses, getNatureFormatDomainErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/nature-format-domain',
    ...options
});

/**
 * create_offerer <POST>
 */
export const createOfferer = <ThrowOnError extends boolean = true>(options: Options<postOfferersData, ThrowOnError>): RequestResult<postOfferersResponses, postOfferersErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postOfferersResponses, postOfferersErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/offerers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * list_educational_offerers <GET>
 */
export const listEducationalOfferers = <ThrowOnError extends boolean = true>(options?: Options<getOfferersEducationalData, ThrowOnError>): RequestResult<getOfferersEducationalResponses, getOfferersEducationalErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<getOfferersEducationalResponses, getOfferersEducationalErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/offerers/educational',
    ...options
});

/**
 * list_offerers_names <GET>
 */
export const listOfferersNames = <ThrowOnError extends boolean = true>(options?: Options<getOfferersNamesData, ThrowOnError>): RequestResult<getOfferersNamesResponses, getOfferersNamesErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<getOfferersNamesResponses, getOfferersNamesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/offerers/names',
    ...options
});

/**
 * signup_structure <POST>
 */
export const signupStructure = <ThrowOnError extends boolean = true>(options: Options<postOfferersNewData, ThrowOnError>): RequestResult<postOfferersNewResponses, postOfferersNewErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postOfferersNewResponses, postOfferersNewErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/offerers/new',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * get_offerer <GET>
 */
export const getOfferer = <ThrowOnError extends boolean = true>(options: Options<getOfferersByOffererIdData, ThrowOnError>): RequestResult<getOfferersByOffererIdResponses, getOfferersByOffererIdErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getOfferersByOffererIdResponses, getOfferersByOffererIdErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/offerers/{offerer_id}',
    ...options
});

/**
 * get_offerer_bank_accounts_and_attached_venues <GET>
 */
export const getOffererBankAccountsAndAttachedVenues = <ThrowOnError extends boolean = true>(options: Options<getOfferersByOffererIdBankAccountsData, ThrowOnError>): RequestResult<getOfferersByOffererIdBankAccountsResponses, getOfferersByOffererIdBankAccountsErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getOfferersByOffererIdBankAccountsResponses, getOfferersByOffererIdBankAccountsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/offerers/{offerer_id}/bank-accounts',
    ...options
});

/**
 * link_venue_to_bank_account <PATCH>
 */
export const linkVenueToBankAccount = <ThrowOnError extends boolean = true>(options: Options<patchOfferersByOffererIdBankAccountsByBankAccountIdData, ThrowOnError>): RequestResult<patchOfferersByOffererIdBankAccountsByBankAccountIdResponses, patchOfferersByOffererIdBankAccountsByBankAccountIdErrors, ThrowOnError, 'data'> => (options.client ?? client).patch<patchOfferersByOffererIdBankAccountsByBankAccountIdResponses, patchOfferersByOffererIdBankAccountsByBankAccountIdErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/offerers/{offerer_id}/bank-accounts/{bank_account_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * invite_member <POST>
 */
export const inviteMember = <ThrowOnError extends boolean = true>(options: Options<postOfferersByOffererIdInviteData, ThrowOnError>): RequestResult<postOfferersByOffererIdInviteResponses, postOfferersByOffererIdInviteErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postOfferersByOffererIdInviteResponses, postOfferersByOffererIdInviteErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/offerers/{offerer_id}/invite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * invite_member_again <POST>
 */
export const inviteMemberAgain = <ThrowOnError extends boolean = true>(options: Options<postOfferersByOffererIdInviteAgainData, ThrowOnError>): RequestResult<postOfferersByOffererIdInviteAgainResponses, postOfferersByOffererIdInviteAgainErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postOfferersByOffererIdInviteAgainResponses, postOfferersByOffererIdInviteAgainErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/offerers/{offerer_id}/invite-again',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * get_offerer_members <GET>
 */
export const getOffererMembers = <ThrowOnError extends boolean = true>(options: Options<getOfferersByOffererIdMembersData, ThrowOnError>): RequestResult<getOfferersByOffererIdMembersResponses, getOfferersByOffererIdMembersErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getOfferersByOffererIdMembersResponses, getOfferersByOffererIdMembersErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/offerers/{offerer_id}/members',
    ...options
});

/**
 * get_offerer_addresses <GET>
 */
export const getOffererAddresses = <ThrowOnError extends boolean = true>(options: Options<getOfferersByOffererIdOffererAddressesData, ThrowOnError>): RequestResult<getOfferersByOffererIdOffererAddressesResponses, getOfferersByOffererIdOffererAddressesErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getOfferersByOffererIdOffererAddressesResponses, getOfferersByOffererIdOffererAddressesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/offerers/{offerer_id}/offerer_addresses',
    ...options
});

/**
 * synchronize_offerer_onboarding <POST>
 */
export const synchronizeOffererOnboarding = <ThrowOnError extends boolean = true>(options: Options<postOfferersByOffererIdSynchronizeOnboardingData, ThrowOnError>): RequestResult<postOfferersByOffererIdSynchronizeOnboardingResponses, postOfferersByOffererIdSynchronizeOnboardingErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postOfferersByOffererIdSynchronizeOnboardingResponses, postOfferersByOffererIdSynchronizeOnboardingErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/offerers/{offerer_id}/synchronize-onboarding',
    ...options
});

/**
 * list_offers <GET>
 */
export const listOffers = <ThrowOnError extends boolean = true>(options?: Options<getOffersData, ThrowOnError>): RequestResult<getOffersResponses, getOffersErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<getOffersResponses, getOffersErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/offers',
    ...options
});

/**
 * patch_offers_active_status <PATCH>
 */
export const patchOffersActiveStatus = <ThrowOnError extends boolean = true>(options: Options<patchOffersActiveStatusData, ThrowOnError>): RequestResult<patchOffersActiveStatusResponses, patchOffersActiveStatusErrors, ThrowOnError, 'data'> => (options.client ?? client).patch<patchOffersActiveStatusResponses, patchOffersActiveStatusErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/offers/active-status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * patch_all_offers_active_status <PATCH>
 */
export const patchAllOffersActiveStatus = <ThrowOnError extends boolean = true>(options: Options<patchOffersAllActiveStatusData, ThrowOnError>): RequestResult<patchOffersAllActiveStatusResponses, patchOffersAllActiveStatusErrors, ThrowOnError, 'data'> => (options.client ?? client).patch<patchOffersAllActiveStatusResponses, patchOffersAllActiveStatusErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/offers/all-active-status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * get_categories <GET>
 */
export const getCategories = <ThrowOnError extends boolean = true>(options?: Options<getOffersCategoriesData, ThrowOnError>): RequestResult<getOffersCategoriesResponses, getOffersCategoriesErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<getOffersCategoriesResponses, getOffersCategoriesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/offers/categories',
    ...options
});

/**
 * delete_draft_offers <POST>
 */
export const deleteDraftOffers = <ThrowOnError extends boolean = true>(options: Options<postOffersDeleteDraftData, ThrowOnError>): RequestResult<postOffersDeleteDraftResponses, postOffersDeleteDraftErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postOffersDeleteDraftResponses, postOffersDeleteDraftErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/offers/delete-draft',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * delete_headline_offer <POST>
 */
export const deleteHeadlineOffer = <ThrowOnError extends boolean = true>(options: Options<postOffersDeleteHeadlineData, ThrowOnError>): RequestResult<postOffersDeleteHeadlineResponses, postOffersDeleteHeadlineErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postOffersDeleteHeadlineResponses, postOffersDeleteHeadlineErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/offers/delete_headline',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * list_offers_home <GET>
 */
export const listOffersHome = <ThrowOnError extends boolean = true>(options: Options<getOffersHomeData, ThrowOnError>): RequestResult<getOffersHomeResponses, getOffersHomeErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getOffersHomeResponses, getOffersHomeErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/offers/home',
    ...options
});

/**
 * get_music_types <GET>
 */
export const getMusicTypes = <ThrowOnError extends boolean = true>(options?: Options<getOffersMusicTypesData, ThrowOnError>): RequestResult<getOffersMusicTypesResponses, getOffersMusicTypesErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<getOffersMusicTypesResponses, getOffersMusicTypesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/offers/music-types',
    ...options
});

/**
 * patch_publish_offer <PATCH>
 */
export const patchPublishOffer = <ThrowOnError extends boolean = true>(options: Options<patchOffersPublishData, ThrowOnError>): RequestResult<patchOffersPublishResponses, patchOffersPublishErrors, ThrowOnError, 'data'> => (options.client ?? client).patch<patchOffersPublishResponses, patchOffersPublishErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/offers/publish',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * create_thumbnail <POST>
 */
export const createThumbnail = <ThrowOnError extends boolean = true>(options: Options<postOffersThumbnailsData, ThrowOnError>): RequestResult<postOffersThumbnailsResponses, postOffersThumbnailsErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postOffersThumbnailsResponses, postOffersThumbnailsErrors, ThrowOnError, 'data'>({
    ...formDataBodySerializer,
    responseStyle: 'data',
    url: '/offers/thumbnails',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * delete_thumbnail <DELETE>
 */
export const deleteThumbnail = <ThrowOnError extends boolean = true>(options: Options<deleteOffersThumbnailsByOfferIdData, ThrowOnError>): RequestResult<deleteOffersThumbnailsByOfferIdResponses, deleteOffersThumbnailsByOfferIdErrors, ThrowOnError, 'data'> => (options.client ?? client).delete<deleteOffersThumbnailsByOfferIdResponses, deleteOffersThumbnailsByOfferIdErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/offers/thumbnails/{offer_id}',
    ...options
});

/**
 * upsert_headline_offer <POST>
 */
export const upsertHeadlineOffer = <ThrowOnError extends boolean = true>(options: Options<postOffersUpsertHeadlineData, ThrowOnError>): RequestResult<postOffersUpsertHeadlineResponses, postOffersUpsertHeadlineErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postOffersUpsertHeadlineResponses, postOffersUpsertHeadlineErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/offers/upsert_headline',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * get_offer <GET>
 */
export const getOffer = <ThrowOnError extends boolean = true>(options: Options<getOffersByOfferIdData, ThrowOnError>): RequestResult<getOffersByOfferIdResponses, getOffersByOfferIdErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getOffersByOfferIdResponses, getOffersByOfferIdErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/offers/{offer_id}',
    ...options
});

/**
 * patch_offer <PATCH>
 */
export const patchOffer = <ThrowOnError extends boolean = true>(options: Options<patchOffersByOfferIdData, ThrowOnError>): RequestResult<patchOffersByOfferIdResponses, patchOffersByOfferIdErrors, ThrowOnError, 'data'> => (options.client ?? client).patch<patchOffersByOfferIdResponses, patchOffersByOfferIdErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/offers/{offer_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * get_offer_exposure <GET>
 */
export const getOfferExposure = <ThrowOnError extends boolean = true>(options: Options<getOffersByOfferIdExposureData, ThrowOnError>): RequestResult<getOffersByOfferIdExposureResponses, getOffersByOfferIdExposureErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getOffersByOfferIdExposureResponses, getOffersByOfferIdExposureErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/offers/{offer_id}/exposure',
    ...options
});

/**
 * post_highlight_request_offer <POST>
 */
export const postHighlightRequestOffer = <ThrowOnError extends boolean = true>(options: Options<postOffersByOfferIdHighlightRequestsData, ThrowOnError>): RequestResult<postOffersByOfferIdHighlightRequestsResponses, postOffersByOfferIdHighlightRequestsErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postOffersByOfferIdHighlightRequestsResponses, postOffersByOfferIdHighlightRequestsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/offers/{offer_id}/highlight-requests',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Replace all price categories of an offer.
 *
 * - If a price category exists in the DB but not in `price_categories`, it is deleted. - Otherwise, price categories are updated or created as needed.
 */
export const replaceOfferPriceCategories = <ThrowOnError extends boolean = true>(options: Options<putOffersByOfferIdPriceCategoriesData, ThrowOnError>): RequestResult<putOffersByOfferIdPriceCategoriesResponses, putOffersByOfferIdPriceCategoriesErrors, ThrowOnError, 'data'> => (options.client ?? client).put<putOffersByOfferIdPriceCategoriesResponses, putOffersByOfferIdPriceCategoriesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/offers/{offer_id}/price_categories',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * get_stocks_stats <GET>
 */
export const getStocksStats = <ThrowOnError extends boolean = true>(options: Options<getOffersByOfferIdStocksStatsData, ThrowOnError>): RequestResult<getOffersByOfferIdStocksStatsResponses, getOffersByOfferIdStocksStatsErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getOffersByOfferIdStocksStatsResponses, getOffersByOfferIdStocksStatsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/offers/{offer_id}/stocks-stats',
    ...options
});

/**
 * get_stocks <GET>
 */
export const getStocks = <ThrowOnError extends boolean = true>(options: Options<getOffersByOfferIdStocksData, ThrowOnError>): RequestResult<getOffersByOfferIdStocksResponses, getOffersByOfferIdStocksErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getOffersByOfferIdStocksResponses, getOffersByOfferIdStocksErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/offers/{offer_id}/stocks/',
    ...options
});

/**
 * Upsert all price categories stocks of a non-event offer.
 *
 * - If a stock exists in the DB but not in `stocks`, it is soft-deleted. - Otherwise, stocks are updated or created as needed.
 */
export const upsertOfferStocks = <ThrowOnError extends boolean = true>(options: Options<patchOffersByOfferIdStocksData, ThrowOnError>): RequestResult<patchOffersByOfferIdStocksResponses, patchOffersByOfferIdStocksErrors, ThrowOnError, 'data'> => (options.client ?? client).patch<patchOffersByOfferIdStocksResponses, patchOffersByOfferIdStocksErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/offers/{offer_id}/stocks/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * delete_stocks <POST>
 */
export const deleteStocks = <ThrowOnError extends boolean = true>(options: Options<postOffersByOfferIdStocksDeleteData, ThrowOnError>): RequestResult<postOffersByOfferIdStocksDeleteResponses, postOffersByOfferIdStocksDeleteErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postOffersByOfferIdStocksDeleteResponses, postOffersByOfferIdStocksDeleteErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/offers/{offer_id}/stocks/delete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * update_offer_video <PUT>
 */
export const updateOfferVideo = <ThrowOnError extends boolean = true>(options: Options<putOffersByOfferIdVideoData, ThrowOnError>): RequestResult<putOffersByOfferIdVideoResponses, putOffersByOfferIdVideoErrors, ThrowOnError, 'data'> => (options.client ?? client).put<putOffersByOfferIdVideoResponses, putOffersByOfferIdVideoErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/offers/{offer_id}/video',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * get_active_venue_offer_by_ean <GET>
 */
export const getActiveVenueOfferByEan = <ThrowOnError extends boolean = true>(options: Options<getOffersByVenueIdEanByEanData, ThrowOnError>): RequestResult<getOffersByVenueIdEanByEanResponses, getOffersByVenueIdEanByEanErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getOffersByVenueIdEanByEanResponses, getOffersByVenueIdEanByEanErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/offers/{venue_id}/ean/{ean}',
    ...options
});

/**
 * bulk_update_event_stocks <PATCH>
 */
export const bulkUpdateEventStocks = <ThrowOnError extends boolean = true>(options: Options<patchStocksBulkData, ThrowOnError>): RequestResult<patchStocksBulkResponses, patchStocksBulkErrors, ThrowOnError, 'data'> => (options.client ?? client).patch<patchStocksBulkResponses, patchStocksBulkErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/stocks/bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * bulk_create_event_stocks <POST>
 */
export const bulkCreateEventStocks = <ThrowOnError extends boolean = true>(options: Options<postStocksBulkData, ThrowOnError>): RequestResult<postStocksBulkResponses, postStocksBulkErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postStocksBulkResponses, postStocksBulkErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/stocks/bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * check_structure <GET>
 */
export const checkStructure = <ThrowOnError extends boolean = true>(options: Options<getStructureCheckBySearchInputData, ThrowOnError>): RequestResult<getStructureCheckBySearchInputResponses, getStructureCheckBySearchInputErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getStructureCheckBySearchInputResponses, getStructureCheckBySearchInputErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/structure/check/{search_input}',
    ...options
});

/**
 * get_structure_data <GET>
 */
export const getStructureData = <ThrowOnError extends boolean = true>(options: Options<getStructureSearchBySearchInputData, ThrowOnError>): RequestResult<getStructureSearchBySearchInputResponses, getStructureSearchBySearchInputErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getStructureSearchBySearchInputResponses, getStructureSearchBySearchInputErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/structure/search/{search_input}',
    ...options
});

/**
 * simulate_signup <POST>
 */
export const simulateSignup = <ThrowOnError extends boolean = true>(options: Options<postStructureSimulateSignupData, ThrowOnError>): RequestResult<postStructureSimulateSignupResponses, postStructureSimulateSignupErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postStructureSimulateSignupResponses, postStructureSimulateSignupErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/structure/simulate-signup',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * send_signup_simulation_summary <POST>
 */
export const sendSignupSimulationSummary = <ThrowOnError extends boolean = true>(options: Options<postStructureSummariseSignupData, ThrowOnError>): RequestResult<postStructureSummariseSignupResponses, postStructureSummariseSignupErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postStructureSummariseSignupResponses, postStructureSummariseSignupErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/structure/summarise-signup',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * anonymize <POST>
 */
export const anonymize = <ThrowOnError extends boolean = true>(options?: Options<postUsersAnonymizeData, ThrowOnError>): RequestResult<postUsersAnonymizeResponses, postUsersAnonymizeErrors, ThrowOnError, 'data'> => (options?.client ?? client).post<postUsersAnonymizeResponses, postUsersAnonymizeErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/users/anonymize',
    ...options
});

/**
 * get_pro_anonymization_eligibility <GET>
 */
export const getProAnonymizationEligibility = <ThrowOnError extends boolean = true>(options?: Options<getUsersAnonymizeEligibilityData, ThrowOnError>): RequestResult<getUsersAnonymizeEligibilityResponses, getUsersAnonymizeEligibilityErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<getUsersAnonymizeEligibilityResponses, getUsersAnonymizeEligibilityErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/users/anonymize/eligibility',
    ...options
});

/**
 * post_check_token <POST>
 */
export const postCheckToken = <ThrowOnError extends boolean = true>(options: Options<postUsersCheckTokenData, ThrowOnError>): RequestResult<postUsersCheckTokenResponses, postUsersCheckTokenErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postUsersCheckTokenResponses, postUsersCheckTokenErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/users/check-token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * connect_as <GET>
 */
export const connectAs = <ThrowOnError extends boolean = true>(options: Options<getUsersConnectAsByTokenData, ThrowOnError>): RequestResult<getUsersConnectAsByTokenResponses, getUsersConnectAsByTokenErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getUsersConnectAsByTokenResponses, getUsersConnectAsByTokenErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/users/connect-as/{token}',
    ...options
});

/**
 * cookies_consent <POST>
 */
export const cookiesConsent = <ThrowOnError extends boolean = true>(options: Options<postUsersCookiesData, ThrowOnError>): RequestResult<postUsersCookiesResponses, postUsersCookiesErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postUsersCookiesResponses, postUsersCookiesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/users/cookies',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * get_profile <GET>
 */
export const getProfile = <ThrowOnError extends boolean = true>(options?: Options<getUsersCurrentData, ThrowOnError>): RequestResult<getUsersCurrentResponses, getUsersCurrentErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<getUsersCurrentResponses, getUsersCurrentErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/users/current',
    ...options
});

/**
 * post_user_email <POST>
 */
export const postUserEmail = <ThrowOnError extends boolean = true>(options: Options<postUsersEmailData, ThrowOnError>): RequestResult<postUsersEmailResponses, postUsersEmailErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postUsersEmailResponses, postUsersEmailErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/users/email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * get_user_email_pending_validation <GET>
 */
export const getUserEmailPendingValidation = <ThrowOnError extends boolean = true>(options?: Options<getUsersEmailPendingValidationData, ThrowOnError>): RequestResult<getUsersEmailPendingValidationResponses, getUsersEmailPendingValidationErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<getUsersEmailPendingValidationResponses, getUsersEmailPendingValidationErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/users/email_pending_validation',
    ...options
});

/**
 * patch_user_identity <PATCH>
 */
export const patchUserIdentity = <ThrowOnError extends boolean = true>(options: Options<patchUsersIdentityData, ThrowOnError>): RequestResult<patchUsersIdentityResponses, patchUsersIdentityErrors, ThrowOnError, 'data'> => (options.client ?? client).patch<patchUsersIdentityResponses, patchUsersIdentityErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/users/identity',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * submit_user_review <POST>
 */
export const submitUserReview = <ThrowOnError extends boolean = true>(options: Options<postUsersLogUserReviewData, ThrowOnError>): RequestResult<postUsersLogUserReviewResponses, postUsersLogUserReviewErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postUsersLogUserReviewResponses, postUsersLogUserReviewErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/users/log-user-review',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * post_new_password <POST>
 */
export const postNewPassword = <ThrowOnError extends boolean = true>(options: Options<postUsersNewPasswordData, ThrowOnError>): RequestResult<postUsersNewPasswordResponses, postUsersNewPasswordErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postUsersNewPasswordResponses, postUsersNewPasswordErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/users/new-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * post_change_password <POST>
 */
export const postChangePassword = <ThrowOnError extends boolean = true>(options: Options<postUsersPasswordData, ThrowOnError>): RequestResult<postUsersPasswordResponses, postUsersPasswordErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postUsersPasswordResponses, postUsersPasswordErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/users/password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * patch_user_phone <PATCH>
 */
export const patchUserPhone = <ThrowOnError extends boolean = true>(options: Options<patchUsersPhoneData, ThrowOnError>): RequestResult<patchUsersPhoneResponses, patchUsersPhoneErrors, ThrowOnError, 'data'> => (options.client ?? client).patch<patchUsersPhoneResponses, patchUsersPhoneErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/users/phone',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * reset_password <POST>
 */
export const resetPassword = <ThrowOnError extends boolean = true>(options: Options<postUsersResetPasswordData, ThrowOnError>): RequestResult<postUsersResetPasswordResponses, postUsersResetPasswordErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postUsersResetPasswordResponses, postUsersResetPasswordErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/users/reset-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * signin <POST>
 */
export const signin = <ThrowOnError extends boolean = true>(options: Options<postUsersSigninData, ThrowOnError>): RequestResult<postUsersSigninResponses, postUsersSigninErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postUsersSigninResponses, postUsersSigninErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/users/signin',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * signout <GET>
 */
export const signout = <ThrowOnError extends boolean = true>(options?: Options<getUsersSignoutData, ThrowOnError>): RequestResult<getUsersSignoutResponses, getUsersSignoutErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<getUsersSignoutResponses, getUsersSignoutErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/users/signout',
    ...options
});

/**
 * signup_pro <POST>
 */
export const signupPro = <ThrowOnError extends boolean = true>(options: Options<postUsersSignupData, ThrowOnError>): RequestResult<postUsersSignupResponses, postUsersSignupErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postUsersSignupResponses, postUsersSignupErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/users/signup',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * patch_validate_email <PATCH>
 */
export const patchValidateEmail = <ThrowOnError extends boolean = true>(options: Options<patchUsersValidateEmailData, ThrowOnError>): RequestResult<patchUsersValidateEmailResponses, patchUsersValidateEmailErrors, ThrowOnError, 'data'> => (options.client ?? client).patch<patchUsersValidateEmailResponses, patchUsersValidateEmailErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/users/validate_email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * validate_user <PATCH>
 */
export const validateUser = <ThrowOnError extends boolean = true>(options: Options<patchUsersValidateSignupByTokenData, ThrowOnError>): RequestResult<patchUsersValidateSignupByTokenResponses, patchUsersValidateSignupByTokenErrors, ThrowOnError, 'data'> => (options.client ?? client).patch<patchUsersValidateSignupByTokenResponses, patchUsersValidateSignupByTokenErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/users/validate_signup/{token}',
    ...options
});

/**
 * create_offer <POST>
 */
export const createOffer = <ThrowOnError extends boolean = true>(options: Options<postV2OffersData, ThrowOnError>): RequestResult<postV2OffersResponses, postV2OffersErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postV2OffersResponses, postV2OffersErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/v2/offers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * delete_venue_provider <DELETE>
 */
export const deleteVenueProvider = <ThrowOnError extends boolean = true>(options: Options<deleteVenueProvidersByVenueProviderIdData, ThrowOnError>): RequestResult<deleteVenueProvidersByVenueProviderIdResponses, deleteVenueProvidersByVenueProviderIdErrors, ThrowOnError, 'data'> => (options.client ?? client).delete<deleteVenueProvidersByVenueProviderIdResponses, deleteVenueProvidersByVenueProviderIdErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/venue-providers/{venue_provider_id}',
    ...options
});

/**
 * update_venue_provider <PUT>
 */
export const updateVenueProvider = <ThrowOnError extends boolean = true>(options: Options<putVenueProvidersByVenueProviderIdData, ThrowOnError>): RequestResult<putVenueProvidersByVenueProviderIdResponses, putVenueProvidersByVenueProviderIdErrors, ThrowOnError, 'data'> => (options.client ?? client).put<putVenueProvidersByVenueProviderIdResponses, putVenueProvidersByVenueProviderIdErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/venue-providers/{venue_provider_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * get_venues <GET>
 */
export const getVenues = <ThrowOnError extends boolean = true>(options?: Options<getVenuesData, ThrowOnError>): RequestResult<getVenuesResponses, getVenuesErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<getVenuesResponses, getVenuesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/venues',
    ...options
});

/**
 * get_venues_educational_statuses <GET>
 */
export const getVenuesEducationalStatuses = <ThrowOnError extends boolean = true>(options?: Options<getVenuesEducationalStatusesData, ThrowOnError>): RequestResult<getVenuesEducationalStatusesResponses, getVenuesEducationalStatusesErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<getVenuesEducationalStatusesResponses, getVenuesEducationalStatusesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/venues-educational-statuses',
    ...options
});

/**
 * get_venues_of_offerer_from_siret <GET>
 */
export const getVenuesOfOffererFromSiret = <ThrowOnError extends boolean = true>(options: Options<getVenuesSiretBySiretData, ThrowOnError>): RequestResult<getVenuesSiretBySiretResponses, getVenuesSiretBySiretErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getVenuesSiretBySiretResponses, getVenuesSiretBySiretErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/venues/siret/{siret}',
    ...options
});

/**
 * get_venue <GET>
 */
export const getVenue = <ThrowOnError extends boolean = true>(options: Options<getVenuesByVenueIdData, ThrowOnError>): RequestResult<getVenuesByVenueIdResponses, getVenuesByVenueIdErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getVenuesByVenueIdResponses, getVenuesByVenueIdErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/venues/{venue_id}',
    ...options
});

/**
 * edit_venue <PATCH>
 */
export const editVenue = <ThrowOnError extends boolean = true>(options: Options<patchVenuesByVenueIdData, ThrowOnError>): RequestResult<patchVenuesByVenueIdResponses, patchVenuesByVenueIdErrors, ThrowOnError, 'data'> => (options.client ?? client).patch<patchVenuesByVenueIdResponses, patchVenuesByVenueIdErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/venues/{venue_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * delete_venue_banner <DELETE>
 */
export const deleteVenueBanner = <ThrowOnError extends boolean = true>(options: Options<deleteVenuesByVenueIdBannerData, ThrowOnError>): RequestResult<deleteVenuesByVenueIdBannerResponses, deleteVenuesByVenueIdBannerErrors, ThrowOnError, 'data'> => (options.client ?? client).delete<deleteVenuesByVenueIdBannerResponses, deleteVenuesByVenueIdBannerErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/venues/{venue_id}/banner',
    ...options
});

/**
 * close_venue <POST>
 */
export const closeVenue = <ThrowOnError extends boolean = true>(options: Options<postVenuesByVenueIdCloseData, ThrowOnError>): RequestResult<postVenuesByVenueIdCloseResponses, postVenuesByVenueIdCloseErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postVenuesByVenueIdCloseResponses, postVenuesByVenueIdCloseErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/venues/{venue_id}/close',
    ...options
});

/**
 * edit_venue_collective_data <PATCH>
 */
export const editVenueCollectiveData = <ThrowOnError extends boolean = true>(options: Options<patchVenuesByVenueIdCollectiveDataData, ThrowOnError>): RequestResult<patchVenuesByVenueIdCollectiveDataResponses, patchVenuesByVenueIdCollectiveDataErrors, ThrowOnError, 'data'> => (options.client ?? client).patch<patchVenuesByVenueIdCollectiveDataResponses, patchVenuesByVenueIdCollectiveDataErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/venues/{venue_id}/collective-data',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * get_venue_headline_offer <GET>
 */
export const getVenueHeadlineOffer = <ThrowOnError extends boolean = true>(options: Options<getVenuesByVenueIdHeadlineOfferData, ThrowOnError>): RequestResult<getVenuesByVenueIdHeadlineOfferResponses, getVenuesByVenueIdHeadlineOfferErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getVenuesByVenueIdHeadlineOfferResponses, getVenuesByVenueIdHeadlineOfferErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/venues/{venue_id}/headline-offer',
    ...options
});

/**
 * get_venue_addresses <GET>
 */
export const getVenueAddresses = <ThrowOnError extends boolean = true>(options: Options<getVenuesByVenueIdLocationsData, ThrowOnError>): RequestResult<getVenuesByVenueIdLocationsResponses, getVenuesByVenueIdLocationsErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getVenuesByVenueIdLocationsResponses, getVenuesByVenueIdLocationsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/venues/{venue_id}/locations',
    ...options
});

/**
 * get_venue_offers_stats <GET>
 */
export const getVenueOffersStats = <ThrowOnError extends boolean = true>(options: Options<getVenuesByVenueIdOffersStatisticsData, ThrowOnError>): RequestResult<getVenuesByVenueIdOffersStatisticsResponses, getVenuesByVenueIdOffersStatisticsErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getVenuesByVenueIdOffersStatisticsResponses, getVenuesByVenueIdOffersStatisticsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/venues/{venue_id}/offers-statistics',
    ...options
});

/**
 * get_venue_offers_stats_v2 <GET>
 */
export const getVenueOffersStatsV2 = <ThrowOnError extends boolean = true>(options: Options<getVenuesByVenueIdOffersStatisticsV2Data, ThrowOnError>): RequestResult<getVenuesByVenueIdOffersStatisticsV2Responses, getVenuesByVenueIdOffersStatisticsV2Errors, ThrowOnError, 'data'> => (options.client ?? client).get<getVenuesByVenueIdOffersStatisticsV2Responses, getVenuesByVenueIdOffersStatisticsV2Errors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/venues/{venue_id}/offers-statistics-v2',
    ...options
});

/**
 * link_venue_to_pricing_point <POST>
 */
export const linkVenueToPricingPoint = <ThrowOnError extends boolean = true>(options: Options<postVenuesByVenueIdPricingPointData, ThrowOnError>): RequestResult<postVenuesByVenueIdPricingPointResponses, postVenuesByVenueIdPricingPointErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postVenuesByVenueIdPricingPointResponses, postVenuesByVenueIdPricingPointErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/venues/{venue_id}/pricing-point',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * get_providers_by_venue <GET>
 */
export const getProvidersByVenue = <ThrowOnError extends boolean = true>(options: Options<getVenuesByVenueIdProvidersData, ThrowOnError>): RequestResult<getVenuesByVenueIdProvidersResponses, getVenuesByVenueIdProvidersErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getVenuesByVenueIdProvidersResponses, getVenuesByVenueIdProvidersErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/venues/{venue_id}/providers',
    ...options
});

/**
 * list_venue_providers <GET>
 */
export const listVenueProviders = <ThrowOnError extends boolean = true>(options: Options<getVenuesByVenueIdVenueProvidersData, ThrowOnError>): RequestResult<getVenuesByVenueIdVenueProvidersResponses, getVenuesByVenueIdVenueProvidersErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getVenuesByVenueIdVenueProvidersResponses, getVenuesByVenueIdVenueProvidersErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/venues/{venue_id}/venue-providers',
    ...options
});

/**
 * create_venue_provider <POST>
 */
export const createVenueProvider = <ThrowOnError extends boolean = true>(options: Options<postVenuesByVenueIdVenueProvidersData, ThrowOnError>): RequestResult<postVenuesByVenueIdVenueProvidersResponses, postVenuesByVenueIdVenueProvidersErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postVenuesByVenueIdVenueProvidersResponses, postVenuesByVenueIdVenueProvidersErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/venues/{venue_id}/venue-providers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
